module.exports = __webpack_public_path__ + "static/media/project_logo_starrynight.0405844a.png";